import easydropdown from 'easydropdown';

const setupBlog = () => {
  if (!$('body').hasClass('pagetype-blog')) {
    return
  }

  const $dateForm = $('.search-date-form')
  const $dateSubmit = $dateForm.find('button')
  const $searchYear = $('select[name=date_year]')
  const $searchMonth = $('select[name=date_month]')
  const yearMonthMap = $searchYear.data('months')

  $searchYear.on('change', (e) => {
    const selected = e.currentTarget.value

    if (yearMonthMap.hasOwnProperty(selected)) {
      $searchMonth.prop('disabled', false)
      $dateSubmit.prop('disabled', false)

      const months = yearMonthMap[selected]
      let newOptions = '<option value="" selected>&nbsp;</option>'

      for (const month of Object.keys(months)) {
        const monthNum = month < 10 ? `0${month}` : month
        const monthName = months[month]
        newOptions += `<option value="${monthNum}">${monthName}</option>`
      }

      $searchMonth.html(newOptions)

      easydropdown($searchMonth[0]).refresh()
    } else {
      $searchMonth.prop('disabled', true)
      $dateSubmit.prop('disabled', true)
    }
  })

  $dateSubmit.on('click', () => {
    const selectedYear = $searchYear.val()
    const selectedMonth = $searchMonth.val()

    const url = `${$dateForm.prop('action')}/${selectedYear}/${selectedMonth}`

    window.location.href = url
  })
}

setupBlog()
